export default __webpack_public_path__ + "static/media/TD.1f2cc3aa.svg";